import React from 'react';
import { SectionHeader } from '../SectionHeader';
import { CtaButton } from '../CtaButton';
export function ChallengeSection() {
  return <section className="w-full bg-paper px-5 py-16 sm:py-24" data-id="element-118" data-mp="1nq87e7w765hq">
      <SectionHeader eyebrow="The real challenge isn’t always your knowledge" title="It’s Knowing How to Organize What You Find." data-id="element-119" data-mp="1siht1bqa4je7" />

      <div className="mx-auto mt-12 grid max-w-5xl gap-10 lg:grid-cols-[1fr_1.2fr] lg:gap-14" data-id="element-120" data-mp="1xh2tnc9g1536">
        <div className="rounded-3xl bg-navy-900 p-7 sm:p-9" data-id="element-121" data-mp="zvnbamkujy4f">
          <p className="text-lg text-slate-300" data-id="element-122" data-mp="14sdp1396ihmo">Low back pain can present in many different ways.</p>
          <p className="mt-4 font-display text-3xl font-extrabold uppercase leading-tight text-white sm:text-4xl" data-id="element-123" data-mp="19s0dy9yddmbb">
            A useful assessment involves more than <span className="text-brand" data-id="element-124" data-mp="1epa3dplrdxz5">selecting a few physical tests.</span>
          </p>
        </div>

        <div className="space-y-5 text-lg leading-relaxed text-slate-700" data-id="element-125" data-mp="2l9rntchhbycm">
          <p data-id="element-126" data-mp="2q4owujere7pi">
            Some patients describe localized discomfort. Others report symptoms extending into the lower extremity, functional limitations,
            recurrent episodes, or symptoms that require closer attention.
          </p>
          <p data-id="element-127" data-mp="10fcpbebv4fa4">
            You need to gather relevant information, understand the patient’s presentation, consider alternative explanations, recognize
            uncertainty, and identify situations that may require additional medical evaluation.
          </p>
          <p data-id="element-128" data-mp="qiq8d0mnq8dd">That’s why I wanted this collection to focus on the assessment process itself.</p>
          <p data-id="element-129" data-mp="lpdunljinlze">
            The <strong className="text-ink" data-id="element-130" data-mp="lovmbqjkxhb4">Low Back Pain Assessment Blueprint™</strong> brings together educational references, practical
            worksheets, and case-based exercises to help you review the different components of your evaluation in one place.
          </p>
          <p data-id="element-131" data-mp="7q5r6ggblrpe">
            You’ll have a structured resource to revisit when preparing for an assessment, reviewing a case, or refining your documentation
            process.
          </p>
        </div>
      </div>

      <CtaButton label="Bring More Structure to Your Assessments" sub="One-time payment of $27 · Instant access · 7-day guarantee" data-id="element-132" data-mp="3pbph1jec60a5" />
    </section>;
}